import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";

export type SkeletonProps = {
    /** Šířka (výchozí hodnota je 100%) */
    width?: string | number;
    /** Výška (výchozí hodnota je 100%) */
    height?: string | number;
    /**
     * Pokud má hodnotu `true`, nastaví `border-radius: 50%`.
     *
     * Při stejné výšce a šířce bude mít tedy komponenta tvar kruhu, při rozdílné tvar oválu.
     */
    circle?: boolean;
};

const classNames = bemClassNames("skeleton-component");

export const Skeleton: FunctionComponent<SkeletonProps> = ({
    width = "100%",
    height = "100%",
    circle,
}) => (
    <div
        className={classNames({ circle })}
        style={{ width, height }}
    />
);
